import {
  EXPRESS_CONTENT_ROUTE,
  EXPRESS_FILE_UPLOAD_ROUTE,
  EXPRESS_ROUTE,
  RequireAtLeastOne
} from '@kindo/universal';

import { ENV_CONFIG } from './env.consts';

/**
 * IMPORTANT
 * Do not use constants that are based on environment variables in API pages (i.e. apps/next/pages/api)
 */
export const BASE_NEXT_URL = ENV_CONFIG.NEXT_PUBLIC_BASE_NEXT_URL;
export const BASE_API_URL = ENV_CONFIG.NEXT_PUBLIC_API_BASE_URL;
export const TRPC_URL = `${BASE_API_URL}/trpc`;
export const PUSHER_URL = `${BASE_API_URL}/pusher-auth`;

export const ROOT_ROUTE = '/';

// Main nav segment routes
export const WORKSTATION_ROUTE = ROOT_ROUTE;
export const WORKFLOWS_ROUTE = '/agents';

// Subroutes for workflows
// NOTE: do not include leading forward slash because these are subroutes
export const WORKFLOWS_LIBRARY_ROUTE = 'library'; // corresponds to 'my agents' tab
export const WORKFLOWS_FACTORY_ROUTE = 'builder'; // corresponds to 'create an agent' tab

// Chat query params
export const CHAT_ID_QUERY_PARAM = 'chatId';

// Workflow query params
export const WORKFLOW_ID_QUERY_PARAM = 'workflowId';

// Integration query params
export const INTEGRATION_NAME_QUERY_PARAM = 'search';

// Audit Log query params
export const AUDIT_LOG_ROUTE = '/audit-log';
export const AUDIT_LOG_EVENT_ID_QUERY_PARAM = 'auditEventId';

export const NUDGE_QUERY_PARAM = 'type';
export const NUDGE_QUERY_PARAM_VALUE = 'nudge';

// Nav routes
export const SECURITY_SETTINGS_ROUTE = '/security-settings';
export const ORG_SECURITY_SETTINGS_ROUTE = '/org-security';
export const INTEGRATIONS_ROUTE = '/integrations';
export const PROFILE_ROUTE = '/profile';

export const LOGIN_ROUTE = '/login';
export const MAGIC_LINK_ROUTE = '/magic-link';
export const SSO_ROUTE = '/sso';
export const MAGIC_LINK_ERROR_PARAM = 'magicLinkError';
export const LOGIN_RETURN_URL_PARAM = 'returnUrl';
export const SSO_DOMAIN_PARAM = 'ssoDomain';
export const ERROR_PARAM = 'error';

export const STATUS_ROUTE = '/status';

export const VERIFY_ROUTE = '/verify';

export const NEXT_API_ROUTE = '/api';
export const VERSION_ROUTE = NEXT_API_ROUTE + '/version';

// Marketing Website
export const MARKETING_WEBSITE_BASE_URL = 'https://kindo.ai';

export const MARKETING_WEBSITE_CONTACT_URL =
  MARKETING_WEBSITE_BASE_URL + '/contact';

export const PUBLIC_DOCS_URL = 'https://docs.kindo.ai';

type WorkstationRouteInput = RequireAtLeastOne<{
  chatId: string;
  workflowId?: string | undefined;
}>;

// Functions to build routes
export const getWorkstationRoute = ({
  chatId,
  workflowId
}: WorkstationRouteInput): string =>
  `${WORKSTATION_ROUTE}?` +
  (chatId ? `${CHAT_ID_QUERY_PARAM}=${chatId}` : '') +
  (workflowId ? `&${WORKFLOW_ID_QUERY_PARAM}=${workflowId}` : '');

export const getWorkflowBuilderRoute = (workflowId: string): string =>
  `${WORKFLOWS_ROUTE}/${WORKFLOWS_FACTORY_ROUTE}/${workflowId}`;

export const getIntegrationSearchRoute = (integrationName: string): string =>
  `${INTEGRATIONS_ROUTE}?${INTEGRATION_NAME_QUERY_PARAM}=${integrationName}`;

// Content URL that bypasses the proxy
export const getContentFetchUrl = ({
  contentId,
  isDownload,
  isPlaintext
}: {
  contentId: string;
  isDownload: boolean;
  isPlaintext: boolean;
}) =>
  `${BASE_API_URL}${EXPRESS_CONTENT_ROUTE}/${contentId}?download=${isDownload}&plaintext=${isPlaintext}`;

// Custom subdomain used to bypass Cloudflare and avoid upload limits
const FILE_UPLOAD_BASE_URL = ENV_CONFIG.NEXT_PUBLIC_FILE_UPLOAD_BASE_URL;
export const EXPRESS_FILE_UPLOAD_DIRECT_URL =
  FILE_UPLOAD_BASE_URL + EXPRESS_ROUTE + EXPRESS_FILE_UPLOAD_ROUTE;
